@let mainbar = headerService.mainbarConfig();
@let defaultMainbar = headerService.DEFAULT_CONFIG.header?.mainbar;
@let actions = mainbar?.actions;
@let initData = infoService.init();
@let headerBackgroundColor = config.config()?.header?.backgroundColor ?? headerService.DEFAULT_CONFIG.header?.backgroundColor;
@let sidebarOpen = system.sidebarOpen();
@let sidebarMenubar = headerService.menubarConfig();
@let sidebarDefaultMenubar = headerService.DEFAULT_CONFIG.header?.menubar;
@let sidebarDropdownMenu = sidebarMenubar?.dropdownMenu;
@let sidebarDefaultDropdownMenu = sidebarDefaultMenubar?.dropdownMenu;
@let sidebarMenuTextColor =
  sidebarDropdownMenu?.textColor ??
  sidebarDefaultDropdownMenu?.textColor ??
  sidebarMenubar?.textColor ??
  sidebarDefaultMenubar?.textColor ??
  'dark-main';
@let sidebarMenuActiveTextColor =
  sidebarDropdownMenu?.activeTextColor ??
  sidebarDefaultDropdownMenu?.activeTextColor ??
  sidebarMenubar?.activeTextColor ??
  sidebarDefaultMenubar?.activeTextColor ??
  'secondary-main';
@let sidebarMenuTextClass = styleService.getColorClass(sidebarMenuTextColor, 'text');
@let sidebarMenuHoverTextClass = styleService.getColorClass(sidebarMenuActiveTextColor, 'text', 'hover:');
@let sidebarCloseHoverTextClass =
  styleService.getColorClass(
    sidebarMenubar?.activeTextColor ?? sidebarDefaultMenubar?.activeTextColor ?? 'secondary-main',
    'text',
    'hover:'
  );
@let sidebarMenuItemFont = styleService.getFontClasses(sidebarMenubar?.font ?? sidebarDefaultMenubar?.font);
<div
  class="navbar-menu fixed top-0 bottom-0 left-0 z-50 w-full transition-opacity duration-200 sm:max-w-sm"
  [class.opacity-0]="!sidebarOpen"
  [class.opacity-100]="sidebarOpen"
  [class.pointer-events-none]="!sidebarOpen"
  [attr.aria-hidden]="!sidebarOpen"
>
  <button
    class="navbar-backdrop bg-dark-main focus-visible:ring-primary-main fixed inset-0 transition-opacity duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset"
    [class.opacity-0]="!sidebarOpen"
    [class.opacity-50]="sidebarOpen"
    (click)="system.toggleSidebar('closed')"
    [attr.aria-label]="'header.sideBar.closeMenu' | translate"
    [attr.tabindex]="sidebarOpen ? null : -1"
  ></button>
  <nav
    id="sidebar-nav"
    class="relative flex h-full w-full flex-col overflow-y-auto px-5 py-4 shadow-2xl transition-transform duration-200 ease-out"
    [class.-translate-x-full]="!sidebarOpen"
    [class.translate-x-0]="sidebarOpen"
    [class]="styleService.getColorClass(headerBackgroundColor, 'bg')"
    [attr.inert]="!sidebarOpen ? '' : null"
    [attr.aria-label]="'header.aria.navigation' | translate"
  >
    <button
      class="navbar-close focus-visible:ring-primary-main absolute top-4 right-4 z-50 inline-flex size-8 items-center justify-center transition-colors focus-visible:rounded focus-visible:outline-none focus-visible:ring-2"
      [ngClass]="[sidebarMenuTextClass, sidebarCloseHoverTextClass]"
      (click)="system.toggleSidebar('closed')"
      aria-label="{{ 'header.sideBar.closeMenu' | translate }}"
    >
      <gs-icon iconName="x" iconWeight="light" class="text-2xl"></gs-icon>
    </button>
    <!-- SIDEBAR HEADER -->
    <div class="mb-2 flex items-start justify-between">
      <a
        [href]="headerService.logoLink()"
        [attr.aria-label]="'header.aria.homepage' | translate"
        class="focus-visible:ring-primary-main flex w-72 justify-start focus-visible:rounded focus-visible:outline-none focus-visible:ring-2"
        [ngClass]="{
          'row-span-2': mainbar?.logo?.useFullHeight
        }"
      >
        @if (initData?.logo?.medium) {
          <span
            class="relative block h-16 w-full"
            [class.h-22]="mainbar?.logo?.useFullHeight"
            [class.lg:h-40]="mainbar?.logo?.useFullHeight"
            [class.lg:h-28]="!mainbar?.logo?.useFullHeight"
            [class.lg:pl-6]="!headerService.useContainer()"
          >
            @for (p of [initData!.logo!]; track p?.medium ?? 'nopic') {
              <img
                class="object-contain object-left p-2 lg:py-4"
                [ngSrc]="p.medium"
                [ngSrcset]="imageService.DEFAULT_SRCSET"
                [loaderParams]="imageService.getLoaderParams(p)"
                sizes="288px"
                fill
                alt="Logo"
              />
            }
          </span>
        }
      </a>
    </div>
    <!-- MYCHAINSTORE SIDEBAR -->
    @let myChainstoreSide = mainbar?.myChainstore;
    @let myChainstoreSideMode = myChainstoreSide?.displayMode ?? 'both';
    @if (myChainstoreSide && myChainstoreSide.active && myChainstoreSide.icon && myChainstoreSideMode !== 'header') {
      <button
        class="border-medium-shine focus-visible:ring-primary-main flex h-14 min-h-14 w-full cursor-pointer flex-row items-center justify-start border-b bg-transparent text-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset"
        [class.hidden]="drillMenu.isDrilled()"
        [attr.aria-expanded]="myChainstoreService.panelOpen()"
        aria-haspopup="dialog"
        (click)="system.toggleSidebar('closed'); myChainstoreService.openPanel()"
        [ngClass]="[
          styleService.getColorClass(actions?.iconColor ?? 'secondary-main', 'text'),
          styleService.getColorClass(actions?.iconColorHover ?? 'secondary-shade', 'text', 'hover:')
        ]"
      >
        <gs-icon
          class="mr-12 block w-6"
          [iconName]="myChainstoreSide.icon.name"
          [iconWeight]="myChainstoreSide.icon.weight"
          [animation]="myChainstoreSide.icon.animation"
        ></gs-icon>
        <p class="w-full text-left text-xl" [ngClass]="[sidebarMenuItemFont]">
          {{ myChainstoreService.current()?.name ?? ('header.mainbar.myChainstore.label' | translate) }}
        </p>
        <gs-icon iconName="caret-right" iconWeight="light"></gs-icon>
      </button>
    }
    <!-- LANGUAGE SIDEBAR -->
    @let languageSide = mainbar?.language;
    @let pageLanguagesSide = headerService.pageLanguages();
    @if (languageSide && languageSide.active && pageLanguagesSide) {
      <div class="border-medium-shine border-b" [class.hidden]="drillMenu.isDrilled()">
        <button
          class="focus-visible:ring-primary-main flex h-14 min-h-14 w-full cursor-pointer flex-row items-center justify-start bg-transparent text-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset"
          [ngClass]="[
            styleService.getColorClass(actions?.iconColor ?? 'secondary-main', 'text'),
            styleService.getColorClass(actions?.iconColorHover ?? 'secondary-shade', 'text', 'hover:')
          ]"
          (click)="headerService.langSideMenuOpen.set(!headerService.langSideMenuOpen())"
          [attr.aria-expanded]="headerService.langSideMenuOpen()"
        >
          @let langSide = languageService.currentLang;
          @if (langSide) {
            @let languageNameSide = langSide.split('-').join('') | translate;
            <img
              [src]="headerService.flagurl + langSide + '.png'"
              [alt]="languageNameSide"
              class="mr-12 w-6 min-w-6 object-contain pt-0.5"
              [title]="languageNameSide"
            />
            <p class="w-full text-left text-xl" [ngClass]="[sidebarMenuItemFont]">{{ languageNameSide }}</p>
          }
          <gs-icon [iconName]="headerService.langSideMenuOpen() ? 'caret-down' : 'caret-right'" iconWeight="light"></gs-icon>
        </button>
        @if (headerService.langSideMenuOpen()) {
          <ul class="flex flex-col pb-2" role="menu">
            @for (entry of pageLanguagesSide | keyvalue; track entry.key) {
              @let entryNameSide = entry.key.split('-').join('') | translate;
              <li role="none">
                <button
                  role="menuitem"
                  class="focus-visible:ring-primary-main flex w-full cursor-pointer items-center bg-transparent px-2 py-2.5 text-left transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset"
                  [ngClass]="{
                    'font-semibold': entry.key === languageService.currentLang,
                    'hover:bg-light-shine': entry.key !== languageService.currentLang
                  }"
                  (click)="headerService.changeLanguage(entry.key)"
                >
                  <img [src]="headerService.flagurl + entry.key + '.png'" [alt]="entryNameSide" class="mr-5 w-6 object-contain" />
                  <span class="text-lg" [ngClass]="[sidebarMenuItemFont, sidebarMenuTextClass]">{{ entryNameSide }}</span>
                </button>
              </li>
            }
          </ul>
        }
      </div>
    }

    <!-- MENU-ITEMS SIDEBAR -->
    <!-- CUSTOM MENU -->
    <div class="pt-6 pb-2" [class.border-medium-shine]="!drillMenu.isDrilled()" [class.border-b]="!drillMenu.isDrilled()">
      @let sidebarActiveClasses =
        styleService.getColorClass(sidebarMenuActiveTextColor, 'text') +
        styleService.getColorClass(
          sidebarDropdownMenu?.activeBackgroundColor ??
            sidebarDefaultDropdownMenu?.activeBackgroundColor ??
            sidebarMenubar?.activeBackgroundColor ??
            sidebarDefaultMenubar?.activeBackgroundColor ??
            'light-shade',
          'bg'
        );
      @let sidebarRootActiveClasses =
        styleService.getColorClass(sidebarMenubar?.activeTextColor ?? sidebarDefaultMenubar?.activeTextColor ?? 'secondary-main', 'text') +
        styleService.getColorClass(
          sidebarMenubar?.activeBackgroundColor ?? sidebarDefaultMenubar?.activeBackgroundColor ?? 'light-shade',
          'bg'
        );
      @let sidebarHoverRootClasses =
        styleService.getColorClass(
          sidebarMenubar?.activeTextColor ?? sidebarDefaultMenubar?.activeTextColor ?? 'secondary-main',
          'text',
          'hover:'
        ) +
        styleService.getColorClass(
          sidebarMenubar?.activeBackgroundColor ?? sidebarDefaultMenubar?.activeBackgroundColor ?? 'light-shade',
          'bg',
          'hover:'
        );
      @let sidebarHoverSubClasses =
        styleService.getColorClass(sidebarMenuActiveTextColor, 'text', 'hover:') +
        styleService.getColorClass(
          sidebarDropdownMenu?.activeBackgroundColor ??
            sidebarDefaultDropdownMenu?.activeBackgroundColor ??
            sidebarMenubar?.activeBackgroundColor ??
            sidebarDefaultMenubar?.activeBackgroundColor ??
            'light-shade',
          'bg',
          'hover:'
        );
      <sidebar-menu
        #drillMenu
        [items]="headerService.dropdownPages()"
        [sidebarOpen]="sidebarOpen"
        [activeMenuItemClasses]="sidebarActiveClasses"
        [activeRootMenuItemClasses]="sidebarRootActiveClasses"
        [hoverRootItemClasses]="sidebarHoverRootClasses"
        [hoverSubItemClasses]="sidebarHoverSubClasses"
        [activeUnderlined]="
          sidebarDropdownMenu?.activeUnderlined ??
          sidebarDefaultDropdownMenu?.activeUnderlined ??
          sidebarMenubar?.activeUnderlined ??
          sidebarDefaultMenubar?.activeUnderlined ??
          false
        "
        [menuItemClasses]="['text-xl transition-colors min-h-12 py-2', sidebarMenuItemFont].join(' ')"
        [menuItemColorClasses]="sidebarMenuTextClass"
        glyphMarginClass="mr-12"
        photoMarginClass="mr-5"
        [backLabel]="'header.sideBar.back' | translate"
        ariaLabel="Main navigation menu"
        (itemActivated)="system.toggleSidebar('closed')"
      ></sidebar-menu>
    </div>
    <!-- BASIC MENU -->
    @let showSidebarActionIcons = actions?.showIconInSidebar ?? defaultMainbar?.actions?.showIconInSidebar ?? false;
    @let dashboardIcon = actions?.actions?.dashboard?.icon ?? defaultMainbar?.actions?.actions?.dashboard?.icon;
    @let watchlistIcon = actions?.actions?.watchlist?.icon ?? defaultMainbar?.actions?.actions?.watchlist?.icon;
    @let logoutIcon = actions?.actions?.logout?.icon ?? defaultMainbar?.actions?.actions?.logout?.icon;
    <!-- Sidebar actions mirror the desktop mainbar: login state, link target and webshop module gate the markup, the configured (responsive) `active` toggle is resolved in CSS. -->
    @let sidebarActionsShown = headerService.sidebarActionsShown();
    @let urlDashboard = initData?.linkTargets?.dashboard;
    @let urlWatchlist = initData?.linkTargets?.watchlist;
    @if (sidebarActionsShown.dashboard || sidebarActionsShown.watchlist || sidebarActionsShown.logout) {
      <!-- display: contents wrapper that hides the whole block, border included, where no action is active -->
      <div [gsResponsive]="{ visible: headerService.sidebarActionsVisible() }">
        <div class="border-medium-shine border-b py-6" [class.hidden]="drillMenu.isDrilled()" [ngClass]="[sidebarMenuTextClass]">
          @if (sidebarActionsShown.dashboard) {
            <span [gsResponsive]="{ visible: headerService.sidebarActionActive('dashboard') ?? false }">
              <a
                [href]="system.getLink(urlDashboard)"
                class="focus-visible:ring-primary-main flex h-14 cursor-pointer flex-row items-center text-xl transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset"
                [ngClass]="[sidebarMenuHoverTextClass]"
              >
                @if (showSidebarActionIcons && dashboardIcon) {
                  <span class="mr-12 inline-flex size-6 shrink-0 items-center justify-center">
                    <gs-icon [iconName]="dashboardIcon.name" [iconWeight]="dashboardIcon.weight" [animation]="dashboardIcon.animation"></gs-icon>
                  </span>
                }
                <span class="text-xl text-inherit" [ngClass]="[sidebarMenuItemFont]">{{ 'header.sideBar.dashboard' | translate }}</span>
              </a>
            </span>
          }
          @if (sidebarActionsShown.watchlist) {
            <span [gsResponsive]="{ visible: headerService.sidebarActionActive('watchlist') ?? false }">
              <a
                [href]="system.getLink(urlWatchlist)"
                class="focus-visible:ring-primary-main flex h-14 cursor-pointer flex-row items-center text-xl transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset"
                [ngClass]="[sidebarMenuHoverTextClass]"
              >
                @if (showSidebarActionIcons && watchlistIcon) {
                  <span class="mr-12 inline-flex size-6 shrink-0 items-center justify-center">
                    <gs-icon [iconName]="watchlistIcon.name" [iconWeight]="watchlistIcon.weight" [animation]="watchlistIcon.animation"></gs-icon>
                  </span>
                }
                <span class="text-xl text-inherit" [ngClass]="[sidebarMenuItemFont]">{{ 'header.sideBar.watchlist' | translate }}</span>
              </a>
            </span>
          }
          @if (sidebarActionsShown.logout) {
            <span [gsResponsive]="{ visible: headerService.sidebarActionActive('logout') ?? false }">
              <button
                type="button"
                (click)="system.toggleSidebar('closed'); headerService.performAction('logout')"
                class="focus-visible:ring-primary-main flex h-14 cursor-pointer flex-row items-center text-xl transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset"
                [ngClass]="[sidebarMenuHoverTextClass]"
              >
                @if (showSidebarActionIcons && logoutIcon) {
                  <span class="mr-12 inline-flex size-6 shrink-0 items-center justify-center">
                    <gs-icon [iconName]="logoutIcon.name" [iconWeight]="logoutIcon.weight" [animation]="logoutIcon.animation"></gs-icon>
                  </span>
                }
                <span class="text-xl text-inherit" [ngClass]="[sidebarMenuItemFont]">{{ 'header.sideBar.logout' | translate }}</span>
              </button>
            </span>
          }
        </div>
      </div>
    }
    <!-- OPENING-HOURS MENU -->
    @if (headerService.showOpeningHoursInSidebar()) {
      <div
        class="border-medium-shine flex flex-col gap-2 border-b py-6"
        [class.hidden]="drillMenu.isDrilled()"
        [ngClass]="[sidebarMenuTextClass]"
      >
        <span class="text-xl text-inherit" [ngClass]="[sidebarMenuItemFont]">{{ 'header.sideBar.openingHours' | translate }}</span>
        <span class="text-base text-inherit" [ngClass]="[sidebarMenuItemFont]">
          {{ headerService.todaysOpeningTime() ?? ('header.loading' | translate) }}
        </span>
      </div>
    }

    <!-- SIDEBAR FOOTER -->
    @let socials = initData?.socialMediaLinks;
    @if (socials) {
      <ul class="mt-auto flex items-center justify-start gap-6 py-6" [class.hidden]="drillMenu.isDrilled()">
        @for (socialMedia of socials | keyvalue; track socialMedia.key) {
          @if (socialMedia.value) {
            <li>
              <a
                [href]="socialMedia.value"
                target="_blank"
                rel="noopener noreferrer"
                class="focus-visible:ring-primary-main focus-visible:rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
                [attr.aria-label]="'footer.social.linkAria' | translate: { platform: socialMedia.key }"
              >
                @let socialMediaKey = socialMedia.key.toLowerCase();
                @let socialIconName = SOCIAL_MEDIA_ICON_MAP[socialMediaKey];
                <gs-icon
                  [iconName]="socialIconName ?? socialMediaKey.toLowerCase()"
                  iconWeight="regular"
                  class="text-xl transition-colors"
                  [ngClass]="[sidebarMenuTextClass, sidebarMenuHoverTextClass]"
                />
              </a>
            </li>
          }
        }
      </ul>
    }
  </nav>
</div>

